import React from "react";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

export const centeredPaperStyle = {
  maxWidth: "min(100%, 560px)",
  width: "100%",
  boxSizing: "border-box",
};

const sectionDividerStyle = {
  borderTop: "1px solid rgba(0, 0, 0, 0.08)",
};

export const useDocumentHtmlStyles = makeStyles((theme) => ({
  documentHtml: {
    "& p, & li, & td, & th": {
      fontSize: theme.typography.body2.fontSize,
      lineHeight: 1.65,
    },
    "& p": {
      marginTop: "0.35em",
      marginBottom: "0.35em",
    },
    "& h1, & h2, & h3, & h4": {
      fontSize: "1rem",
      fontWeight: 600,
      marginTop: "0.5em",
      marginBottom: "0.35em",
      color: theme.palette.text.primary,
    },
    "& ul, & ol": {
      paddingLeft: "1.25rem",
      marginTop: "0.35em",
      marginBottom: "0.35em",
    },
    "& *": {
      maxWidth: "100%",
    },
  },
  scrollBody: {
    maxHeight: "min(55vh, 440px)",
    overflowY: "auto",
    textAlign: "justify",
    color: theme.palette.text.secondary,
  },
}));

export const useActionButtonStyles = makeStyles((theme) => ({
  actionButton: {
    fontSize: "0.84rem",
    fontWeight: 500,
    lineHeight: 1,
    minHeight: 44,
    padding: theme.spacing(1.25, 2),
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiButton-label": {
      lineHeight: 1,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
}));

export const useNavButtonStyles = makeStyles((theme) => ({
  navButton: {
    lineHeight: 1,
    width: "auto",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(1.5, 1.25),
    minHeight: 35,
    "& .MuiButton-label": {
      lineHeight: 1,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  navButtonPrimary: {
    minWidth: 168,
    whiteSpace: "nowrap",
  },
}));

export const ConsentDocumentBody = ({ html }) => {
  const classes = useDocumentHtmlStyles();
  return (
    <Box className={classes.scrollBody}>
      <Typography variant="body2" component="div" color="textSecondary">
        <div
          className={classes.documentHtml}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </Typography>
    </Box>
  );
};

export const ConsentActionButtons = ({ onAccept, onDecline }) => {
  const classes = useActionButtonStyles();
  return (
  <Box mt={2} pt={2} style={sectionDividerStyle}>
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <Button
          fullWidth
          disableElevation
          variant="contained"
          color="primary"
          className={classes.actionButton}
          onClick={onAccept}
        >
          Jag samtycker
        </Button>
      </Grid>
      <Grid item xs={6}>
        <Button
          fullWidth
          disableElevation
          variant="outlined"
          color="secondary"
          className={classes.actionButton}
          onClick={onDecline}
        >
          Jag samtycker inte
        </Button>
      </Grid>
    </Grid>
  </Box>
  );
};
